import logo from '../assets/Bonisoft__signet_iceblue.svg'
import Box from "@mui/material/Box";

const BonisoftLogo = ({ imgRatio }: { imgRatio: number }) => {
  const widthPx = imgRatio * 10;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        verticalAlign: "middle",
        maxWidth: "100%",
        img: {
          width: "100%",
          height: "auto",
          maxWidth: widthPx,
        },
      }}>
      <img src={logo} width={widthPx} alt="BonisoftLogo" />
    </Box>
  )
}

export default BonisoftLogo